import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './ReverseStrikeOffVoter.module.scss'

export const ReverseStrikeOffVoter = ({ confirm, votingDistricts = [], name }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const districtOptions = votingDistricts.map((district) => {
    return { value: district, label: district }
  })

  const formik = useFormik({
    initialValues: { votingDistrict: votingDistricts ? votingDistricts[0] : '' },
    validationSchema: Yup.object({}),
    onSubmit: (values) => confirm(values),
  })

  useEffect(() => {
    setHeaderLabel(t('buttons.reverseStrikeOff'))
    setBtns([
      { text: t('buttons.cancel'), variant: 'secondary', onClick: onClose, isCancel: true },
      { text: t('buttons.reverseStrikeOff'), onClick: confirm },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{t('admin.electorsList.confirmReverseStrikeOff', { name })}</div>
      {/* <div className={styles['section']}>
        <Select
          label={t('admin.electorsList.votingDistrict')}
          formik={formik}
          options={districtOptions}
          field='votingDistrict'
          value={formik.values.votingDistrict}
          isRequired={true}
        />
      </div> */}
    </div>
  )
}
